import { z } from 'zod';
import { CATEGORIES } from './types.js';
/**
 * Validation des payloads entrants. Le serveur refuse tout ce qui ne passe pas
 * ces schemas ; le client s'en sert pour desactiver ses boutons avant l'envoi.
 * Une seule definition, deux usages : les regles ne peuvent pas diverger.
 */
/** Une URL vide est normalisee en null plutot que rejetee : le champ est optionnel. */
const optionalUrl = z
    .string()
    .trim()
    .max(500)
    .refine((v) => v === '' || /^https?:\/\//.test(v), { message: 'URL http(s) attendue' })
    .transform((v) => (v === '' ? null : v))
    .nullable()
    .default(null);
export const sessionSchema = z.object({
    code: z.string().min(1).max(200),
    pseudo: z.string().trim().min(1).max(40),
});
export const createPlaceSchema = z.object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    title: z.string().trim().min(1).max(120),
    description: z.string().trim().max(2000).default(''),
    category: z.enum(CATEGORIES),
    url: optionalUrl,
});
export const updatePlaceSchema = z
    .object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    title: z.string().trim().min(1).max(120),
    description: z.string().trim().max(2000),
    category: z.enum(CATEGORIES),
    url: optionalUrl,
    status: z.enum(['pool', 'itinerary']),
})
    .partial()
    .refine((v) => Object.keys(v).length > 0, { message: 'Aucun champ a modifier' });
export const voteSchema = z.object({ value: z.union([z.literal(-1), z.literal(1)]) });
export const commentSchema = z.object({ body: z.string().trim().min(1).max(2000) });
/** Liste ordonnee complete des lieux de l'itineraire. Le dernier qui ecrit gagne. */
export const itinerarySchema = z.object({
    placeIds: z.array(z.number().int().positive()).max(500),
});
